import { useQuery } from '@tanstack/react-query';
import React from 'react';

import { dataReviewApi } from '@/api/clients/dataReviewApi';
import { useAuth } from '@/context/appContext';

// Split from UserQualityAssuranceService: the sidebar badge needs only this hook, and the service
// itself pulls in the queue item editor.

export const useUserQualityAssuranceAvailableCount = (opts?: { disabled?: boolean }) => {
  const auth = useAuth();

  const qaAvailableCountQuery = useQuery<number>({
    queryKey: ['initial-qa-count'],
    queryFn: async () => {
      const updatedQaSession = await dataReviewApi.appApiQueueReviewGetAvailableCount({
        data_reviewer_id: auth.authInfo!.reviewer_id,
      });
      return updatedQaSession.data;
    },
    refetchInterval: 60 * 1000,
    enabled: !opts?.disabled,
  });
  // biome-ignore lint/correctness/useExhaustiveDependencies: carried over from the former ESLint suppression
  return React.useMemo(() => {
    return {
      numQA2AvailableQueues: qaAvailableCountQuery.isSuccess ? qaAvailableCountQuery.data : 0,
      query: qaAvailableCountQuery,
    };
    // the query returned by useQuery is not stable, we only want to update when data is available/has changed
  }, [qaAvailableCountQuery.isSuccess, qaAvailableCountQuery.data]);
};
